import { Type } from '@warp-drive/core-types/symbols';
import Task from 'volta/models/task';
import { _normalize, collectionCommand } from 'volta/utils/api';
import { TaskCommands } from './task';

import type { TAcquisitionCode } from 'volta/models/constants/acquisition-codes';
import type { TPlanningMethodology } from 'volta/models/types/planning-settings';
import type {
  ICreateTaskCmd,
  IDeleteTaskCmd,
  IReopenTaskCmd,
  IResolveTaskCmd,
  IUpdateTaskCmd
} from './types/tasks';

export interface ILinkedEntityPayload {
  partCode: string;
  description?: string;
  warehouseCode: string;
  methodology?: TPlanningMethodology;
  isProtected: boolean;
  acqCode: TAcquisitionCode;
  isActive: boolean;
}

export default class SkuTask extends Task<Record<string, any>, ILinkedEntityPayload> {
  static modelName = 'sku-task';

  /**
   * Commands
   */

  static createTask = collectionCommand<ICreateTaskCmd, SkuTask, typeof SkuTask>(
    TaskCommands.CreateTask,
    {
      ajaxOptions: { queryParams: { include: 'createdBy,resolvedBy,assignees' } }
    }
  );

  static updateTask = collectionCommand<IUpdateTaskCmd, SkuTask, typeof SkuTask>(
    TaskCommands.UpdateTask
  );

  static deleteTask = collectionCommand<IDeleteTaskCmd, void, typeof SkuTask>(
    TaskCommands.DeleteTask
  );

  static resolveTask = collectionCommand<IResolveTaskCmd, SkuTask, typeof SkuTask>(
    TaskCommands.ResolveTask
  );

  static reopenTask = collectionCommand<IReopenTaskCmd, SkuTask, typeof SkuTask>(
    TaskCommands.ReopenTask
  );

  // @ts-ignore
  [Type] = 'sku-task' as const;
}
